import { jsx as o, jsxs as c } from "@emotion/react/jsx-runtime";
import { useRef as u, useState as f, useMemo as R, useEffect as a, Children as A, isValidElement as k, cloneElement as O } from "react";
import { Tab as P } from "./Tab/Tab.js";
import { TabMenu as h } from "./TabMenu/TabMenu.js";
import { TabMenuItem as M } from "./TabMenuItem/TabMenuItem.js";
import { TabsContainer as j, TabsHeader as U, StyledTabMenu as q, TabMenuWrapped as B } from "./Tabs.styled.js";
import { TabsContext as F } from "./TabsContext.js";
import { Icon as V } from "../Icon/index.js";
import { Stack as _ } from "../Stack/index.js";
import { Text as z } from "../Text/index.js";
import { FontAwesomeIconsPartooUsed as T, IconPrefix as G } from "../../types/components/icon.js";
const J = 10, m = ({
  dataTrackId: v,
  onChange: p,
  moreText: y = "More",
  selected: l,
  className: S,
  children: r = null,
  ...I
}) => {
  const g = u(null), t = u({}), w = u(null), [i, x] = f(!1), [C, E] = f(0), [s, H] = f(!1);
  if (!(r && Array.isArray(r) && r.length > 0 && r.some((e) => !!e)))
    return;
  const L = R(() => ({
    onChange: p,
    selected: l
  }), [l, p]), b = () => x(!i);
  a(() => {
    H(t.current.scrollWidth > t.current.clientWidth);
  }, [r]), a(() => {
    t.current && E(t.current.offsetHeight);
  }, [r]), a(() => {
    const e = t.current.querySelector(
      "[role='tab'][aria-selected='true']"
      // eslint-disable-line quotes
    );
    e && t.current.scrollTo && t.current.scrollTo({
      left: e.offsetLeft,
      behavior: "smooth"
    });
  }, [l]), a(() => {
    const e = t.current, n = w.current, d = () => {
      n?.style && (n.style.boxShadow = e.scrollLeft + J > e.scrollWidth - e.clientWidth ? "none" : "");
    };
    return s && e.addEventListener("scroll", d), () => {
      s && e.removeEventListener("scroll", d);
    };
  }, [s]);
  const W = A.map(r, (e) => {
    let n = null;
    return k(e) && (n = O(e, {
      ...e?.props
    })), {
      value: e?.props.value,
      label: /* @__PURE__ */ o(M, { value: e?.props.value, children: n }),
      disabled: e?.props.disabled
    };
  }), D = i ? T.faCaretUp : T.faCaretDown;
  return /* @__PURE__ */ o(F.Provider, { value: L, children: /* @__PURE__ */ c(j, { children: [
    /* @__PURE__ */ c(U, { "data-track": v, ref: t, role: "tablist", className: S, ...I, children: [
      r,
      s ? /* @__PURE__ */ o(q, { ref: g, onClick: b, children: /* @__PURE__ */ c(_, { direction: "row", alignItems: "center", children: [
        /* @__PURE__ */ o(z, { variant: "bodyLBold", as: "span", children: y }),
        /* @__PURE__ */ o(V, { icon: [D, G.SOLID], color: "secondary" })
      ] }) }) : null
    ] }),
    /* @__PURE__ */ o(B, { height: C, children: /* @__PURE__ */ o(h, { visible: i, closeMenu: b, sections: [{
      options: W
    }] }) })
  ] }) });
};
m.Tab = P;
m.Menu = h;
m.MenuItem = M;
export {
  m as Tabs
};
